import React, { useEffect, useState } from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/outline";
import TextField from "../Reusable/TextInput";
import NumberField from "../Reusable/NumberField";

const Form = ({
  errors,
  register,
  setValue,
  getValues,
  clearErrors,
  fields,
  watch,
  isActive = true,
  remove,
  append,
}: any) => {
  const values = watch("items") || [];

  const totalIn = values.reduce(
    (acc: number, curr: any) => acc + (Number(curr?.debit) || 0),
    0
  );

  const totalOut = values.reduce(
    (acc: number, curr: any) => acc + (Number(curr?.credit) || 0),
    0
  );
  const closingBalance = totalIn - totalOut;

  return (
    <div className={tw`p-4`}>
      {fields.map((field: any, index: any) => (
        <div key={index}>
          <div className={tw`flex gap-x-4 mb-4`}>
            <div className={tw`grid grid-cols-4 gap-2 w-full`}>
              <div className={tw`col-span-3`}>
                <TextField
                  register={register(`items.${index}.description`)}
                  errors={errors?.items?.[index]?.description}
                  disabled={!isActive}
                  placeholder={"Description"}
                />
              </div>
              <TextField
                register={register(`items.${index}.comment`)}
                errors={errors?.items?.[index]?.comment}
                disabled={!isActive}
                placeholder={"Comment"}
              />
            </div>
            <div className={tw`flex gap-x-4`}>
              <NumberField
                value={getValues(`items.${index}.debit`)}
                register={register(`items.${index}.debit`)}
                errors={errors?.items?.[index]?.debit}
                delimiter=","
                placeholder={"In"}
                setValue={setValue}
                clearErrors={clearErrors}
                disabled={!isActive}
              />

              <NumberField
                value={getValues(`items.${index}.credit`)}
                register={register(`items.${index}.credit`)}
                errors={errors?.items?.[index]?.credit}
                delimiter=","
                placeholder="Out"
                setValue={setValue}
                clearErrors={clearErrors}
                disabled={!isActive}
              />
            </div>

            <div
              className={tw`flex items-center justify-start gap-x-2 w-[150px]`}
            >
              <button
                type="button"
                onClick={() =>
                  append({
                    description: null,
                    debit: null,
                    credit: null,
                  })
                }
                className={tw`p-2  border  focus:outline-none`}
              >
                <PlusIcon className={tw`w-5 h-5 text-green-600`} />
              </button>

              {fields.length > 1 && (
                <button
                  type="button"
                  onClick={() => remove(index)}
                  className={tw`p-2  border`}
                >
                  <MinusIcon className={tw`w-5 h-5 text-red-600`} />
                </button>
              )}
            </div>
          </div>
        </div>
      ))}

      <hr />

      <div className={tw`mt-2`}>
        <div className={tw`flex gap-x-4 mb-1`}>
          <div className={tw`w-full flex justify-end items-center`}>
            <p>Total</p>
          </div>
          <div className={tw`flex gap-x-4`}>
            <NumberField
              value={totalIn}
              delimiter=","
              setValue={setValue}
              clearErrors={clearErrors}
              disabled={true}
            />

            <NumberField
              value={totalOut}
              delimiter=","
              setValue={setValue}
              clearErrors={clearErrors}
              disabled={true}
            />
          </div>

          <div
            className={tw`flex items-center justify-start gap-x-2 w-[150px]`}
          ></div>
        </div>
      </div>
      <div className={tw`mt-2`}>
        <div className={tw`flex gap-x-4 mb-1`}>
          <div className={tw`w-full flex justify-end items-center`}>
            <p>Closing Balance</p>
          </div>

          <div
            className={tw`flex  w-[335px] ${
              closingBalance < 0 ? "text-red-600" : "text-green-600"
            }`}
          >
            <div className={tw`w-full`}>
              <NumberField
                key={closingBalance}
                value={closingBalance}
                delimiter=","
                disabled
              />
            </div>
          </div>
          <div className={tw`w-[150px]`} />
        </div>
      </div>

      <hr />
      <div className={tw`pb-2 my-1`}>
        <TextField
          register={register("notes")}
          placeholder={"Remarks"}
          errors={errors?.note}
          disabled={!isActive}
        />
      </div>
    </div>
  );
};

export default Form;

